var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.78,24.98c0,4.3-3.48,7.78-7.78,7.78c-4.29,0-7.78-3.48-7.78-7.78c0-4.29,3.48-7.78,7.78-7.78 C29.3,17.2,32.78,20.68,32.78,24.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.11,28.62l5.69-0.74c0.27-1.93,0.28-3.8,0-5.8l-5.69-0.74c-0.38-1.6-1.01-3.09-1.85-4.45l3.5-4.55 c-1.17-1.55-2.55-2.93-4.1-4.1l-4.55,3.5c-1.36-0.84-2.86-1.46-4.46-1.85l-0.74-5.69c-1.98-0.27-3.84-0.27-5.8,0l-0.74,5.69 c-1.6,0.38-3.1,1.01-4.46,1.85l-4.55-3.5c-1.49,1.12-2.9,2.52-4.1,4.1l3.5,4.55c-0.84,1.36-1.47,2.87-1.85,4.47l-5.69,0.74 c-0.26,1.85-0.27,3.82,0,5.8l5.69,0.74c0.38,1.6,1.02,3.1,1.85,4.47l-3.5,4.55c1.12,1.48,2.52,2.9,4.1,4.1l4.55-3.5 c1.36,0.84,2.86,1.46,4.46,1.85l0.74,5.69c1.96,0.27,3.82,0.27,5.8,0l0.74-5.69c1.6-0.38,3.09-1.01,4.46-1.85l4.55,3.5 c1.55-1.17,2.93-2.55,4.1-4.1l-3.5-4.55C39.1,31.71,39.73,30.22,40.11,28.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsProfile);
export default __webpack_public_path__ + "static/media/settings-profile.c470b11e5db408958e9cd24f75943ffc.svg";
export { ForwardRef as ReactComponent };